export default __webpack_public_path__ + "static/media/volleyball-player-image.69dfcade.png";